/**
 * @format
 * @flow
 */
import AWS from "aws-sdk";
import { AWSConfig } from "../constants/Api";

const dynamoDb = new AWS.DynamoDB.DocumentClient({
  region: AWSConfig.region,
  accessKeyId: AWSConfig.accessKeyId,
  secretAccessKey: AWSConfig.secretAccessKey,
  maxRetries: 70,
  httpOptions: {
    timeout: 3000
  }
});

export function getLicenses(licenseId) {
  return async dispatch => {
    try {
      const result = await _getLicenses(licenseId);
      return Promise.resolve(result);
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

function _getLicenses(licenseId) {
  return new Promise((resolve, reject) => {
    const query = { TableName: AWSConfig.LICENSES_TABLE };
    dynamoDb.scan(query, function(err, result) {
      if (err) {
        // console.log(`Unable to update item. Error JSON`);
        reject(null);
      }

      // console.log(result)
      if (result.Count > 0) {
        const datas = [];
        let defaultName = "";

        result.Items.sort(function(a, b) {
          const aStatus = a.licenseId;
          const bStatus = b.licenseId;
          if (Number(aStatus) > Number(bStatus)) {
            return 1;
          }
          if (Number(aStatus) < Number(bStatus)) {
            return -1;
          }
          return 0;
        });

        result.Items.forEach(item => {
          if (item.deleteFlag === "0") {
            // let check = false;
            for (const key in licenseId) {
              if (licenseId[key] === item.licenseId) {
                // check = true;
                defaultName = item.licenseName;
                break;
              }
            }
            datas.push({ key: item.licenseId, value: item.licenseName });
            // datas.push({licenseId:item.licenseId,licenseName:item.licenseName,activeAt:check});
          }
        });

        resolve({ datas, defaultName });
      }
    });
  });
}
